import { render, staticRenderFns } from "./SalesReadReport.vue?vue&type=template&id=f2048dea&"
import script from "./SalesReadReport.vue?vue&type=script&lang=js&"
export * from "./SalesReadReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports